<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <h4>{{ trans('general.page.space_products.add_product') }}</h4>
        </template>
        <template #content>
            <form action="#" ref="addProductForm" class="pb-5" @submit.prevent="submit">
                <div class="mt-4" style="padding-bottom: 50px">
                    <FormErrorAlerts :errors="errors"></FormErrorAlerts>

                    <div class="fields">
                        <div class="row g-2 mb-2 justify-content-between">
                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                    <input required type="text" v-model="model.name" class="form-control" id="productName"
                                           :placeholder="trans('general.page.space_products.model.name')">
                                    <label for="productName">
                                        {{ trans('general.page.space_products.model.name') }}
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                    <input required type="number" step="0.01" v-model="model.price" class="form-control"
                                           id="productPrice" :placeholder="trans('general.page.space_products.model.price')">
                                    <label for="productPrice">
                                        {{ trans('general.page.space_products.model.price') }} ({{model.currency?.code}})
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                <textarea v-model="model.description" class="form-control" id="productDescription"
                                          :placeholder="trans('general.page.space_products.model.description')"></textarea>
                                    <label for="productDescription">
                                        {{ trans('general.page.space_products.model.description') }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="mt-4 text-secondary fs-12 " v-if="product">{{ trans("general.page.space_products.tip") }}:
                        {{ trans("general.page.space_products.messages.tip") }}.</p>
                </div>
                <nav class="position-fixed nav navbar-light bg-gray-100 bottom-0 right-0  px-4"
                     style="max-width: 576px; width: 100%">
                    <div class="d-flex w-100 gap-2 py-1 justify-content-end">
                        <button class="btn btn-add btn-primary btn-icon-split" type="submit" v-if="!product">
                            <span class="text">{{ trans('general.defaults.add') }}</span>
                        </button>
                        <div v-else>
                            <button  class="btn btn-delete btn-secondary  btn-icon-split" type="button" @click.prevent="deleteProduct()">
                                <span class="text">{{ trans('general.defaults.delete') }}</span>
                                <i class="icon fi d-inline-flex fi-rr-trash"></i>
                            </button>
                            <button  class="btn btn-update btn-primary btn-icon-split" type="submit">
                                <span class="text">{{ trans('general.defaults.update') }}</span>
                            </button>
                        </div>
                    </div>
                </nav>
            </form>
        </template>
    </slideout-content>
</template>

<script>
import CurrencySelect from "../atoms/CurrencySelect.vue";
import FormErrorAlerts from "./FormErrorAlerts.vue";
import {getSpaceCurrency} from "../../services/SpaceBillingContants";
import SlideoutContent from "./SlideoutContent.vue";

export const SUBMIT_INDICATOR = 'SUBMIT_INDICATOR'

export default {
    name: "AddProductQuickForm",
    props: {
      product: Object
    },
    components: {
        SlideoutContent,
        FormErrorAlerts,
        CurrencySelect
    },
    data() {
        return {
            errors: [],
            model: {
                name: null,
                currency: null,
                price: null,
                description: null,
            }
        }
    },
    methods: {
        submit(event) {
            event.preventDefault();
            this.$wait.start(SUBMIT_INDICATOR);
            const {name, price, description, currency} = this.model;
            const url = this.product ? `/space/products/${this.product.id}`:'/space/products/new'

            axios.post(url, {name, price: price * 100, description, currency_code: currency.code})
                .then(response => {
                    this.$wait.end(SUBMIT_INDICATOR);
                    this.$emit('product-saved', response.data.data)
                    this.$emit('closePanel', response.data.data);
                })
                .catch((error) => {
                    this.$wait.end(SUBMIT_INDICATOR);
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                });

        },
        deleteProduct() {
            axios.delete(`/space/products/${this.product.id}`)
                .then(response => {
                    this.$wait.end(SUBMIT_INDICATOR);
                    this.$emit('closePanel', response.data.data);
                })
                .catch((error) => {
                    this.$wait.end(SUBMIT_INDICATOR);
                    this.$notify({type: 'error', text: trans('general.page.space_products.messages.failed_to_delete')});

                });
        },
        closePanel(event) {
            event.preventDefault()
            this.$emit('closePanel', {});
        },
    },
    mounted() {
        if (this.product) {
            this.model = this.product
            this.model.price = Number(this.product.price) / 100
        }
        getSpaceCurrency().then(currency => this.model.currency = currency)
    }
}
</script>
